import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import useContentId from './useContentId';
const SmartContentActivitiesQuery = registerQuery({
  fieldName: 'smartContentActivities',
  fetcher: ({
    pageId
  }) => {
    return http.get('activities/v2/reports/targeted-content/total', {
      query: {
        pageId
      }
    });
  }
});
const useSmartContentActivities = () => {
  const pageId = useContentId();
  const {
    data,
    loading,
    error
  } = useQuery(SmartContentActivitiesQuery, {
    variables: {
      pageId
    },
    skip: !pageId
  });
  const hasActivities = (data === null || data === void 0 ? void 0 : data.smartContentActivities.breakdowns) && (data === null || data === void 0 ? void 0 : data.smartContentActivities.breakdowns.length) > 0;
  return useMemo(() => ({
    hasActivities,
    smartContentActivitiesRequestLoading: loading,
    smartContentActivitiesRequestError: error
  }), [hasActivities, error, loading]);
};
export default useSmartContentActivities;